import { ReactNode } from 'react';
import styles from './StatCard.module.css';
import { TitledCard } from '@/components/Card';

export const StatCard = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <TitledCard title={title} className={styles.statCard}>
      <div className={styles.value}>
        {children}
      </div>
    </TitledCard>
  );
};
